var _defs, _polygon, _polygon2, _polyline, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobArdinShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff1542;\n      }\n\n      .cls-2 {\n        fill: #35202f;\n      }\n\n      .cls-3 {\n        fill: #d61846;\n      }\n\n      .cls-4 {\n        fill: #301d29;\n      }\n\n      .cls-5 {\n        fill: #261722;\n      }\n\n      .cls-6 {\n        fill: #3f2738;\n      }\n\n      .cls-7 {\n        fill: #5b4956;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "501.82 364 478.13 367.56 428.82 367.56 428.82 325.6 501.82 336.56 501.82 364"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "511.82 318.82 511.82 268.82 261.82 318.82 150.82 368.82 220.82 387.82 430.01 387.82 511.82 318.82"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "511.82 318.82 511.82 268.82 261.82 318.82"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "511.82 318.82 477.82 318.82 438.82 283.82 511.82 268.82 511.82 318.82"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "430.82 387.82 220.82 387.82 150.82 368.82 451.82 368.82 430.82 387.82"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "475.82 437.82 339.82 409.82 329.82 396.82 475.82 426.82 475.82 437.82"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "378.82 397.82 256.82 390.82 256.82 385.82 378.82 378.82 378.82 397.82"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "475.45 426.82 329.45 396.82 309.45 355.82 415.45 355.82 475.45 426.82"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "475.82 426.82 329.82 396.82 322.82 383.82 449.82 396.82 475.82 426.82"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "475.82 437.82 339.82 409.82 329.82 396.82 475.82 426.82 475.82 437.82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobArdinShip);
export default __webpack_public_path__ + "static/media/mob-ardin-ship.8ea48d6802b89230283cf63774c5ae37.svg";
export { ForwardRef as ReactComponent };